msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: lt\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-27 06:16\n"
"Last-Translator: \n"
"Language-Team: Lithuanian\n"
"Plural-Forms: nplurals=4; plural=(n%10==1 && (n%100>19 || n%100<11) ? 0 : (n%10>=2 && n%10<=9) && (n%100>19 || n%100<11) ? 1 : n%1!=0 ? 2: 3);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: lt\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "Užrakinta"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Įrašai: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Paskutinį kartą paskelbta: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatizuotas"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1438
msgid "Group"
msgstr "Grupuoti"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Bendri"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Paprašyta"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "Sekama"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Seka tave"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# sekėjas} few {# sekėjai} many {# sekėjo} other {# sekėjų}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Patvirtinta"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "Prisijungė <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Visam laikui"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Nepavyksta įkelti paskyros."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Eiti į paskyros puslapį"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Sekėjai"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Įrašai"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Daugiau"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> nurodė, kad jų naujoji paskyra dabar yra:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Nukopijuotas socialinis medijos vardas"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "Nepavyksta nukopijuoti socialinės medijos vardo"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Kopijuoti socialinės medijos vardą"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Eiti į originalų profilio puslapį"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Peržiūrėti profilio vaizdą"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Peržiūrėti profilio antraštę"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "Atminimui"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Šis naudotojas pasirinko nepadaryti šią informaciją prieinamą."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} originalūs įrašai, {1} atsakymai, {2} pasidalinimai"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Paskutinis {0} įrašas per pastarąją {1} dieną} few {Paskutinis 1 įrašas per pastarąsias {2} dienas} many {Paskutinis 1 įrašas per pastarąsias {2} dienos} other {Paskutinis 1 įrašas per pastarąsias {2} dienų}}} few {{3, plural, one {Paskutiniai {4} įrašai per pastarąją 1 dieną} few {Paskutiniai {5} įrašai per pastarąsias {6} dienas} many {Paskutinio {5} įrašo per pastaruosius {6} dienos} other {Paskutinių {5} įrašų per pastarąsias {6} dienų}}} many {{3, plural, one {Paskutiniai {4} įrašai per pastarąją 1 dieną} few {Paskutiniai {5} įrašai per pastarąsias {6} dienas} many {Paskutinio {5} įrašo per pastaruosius {6} dienos} other {Paskutinių {5} įrašų per pastarąsias {6} dienų}}} other {{3, plural, one {Paskutiniai {4} įrašai per pastarąją 1 dieną} few {Paskutiniai {5} įrašai per pastarąsias {6} dienas} many {Paskutinio {5} įrašo per pastaruosius {6} dienos} other {Paskutinių {5} įrašų per pastarąsias {6} dienų}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Paskutinis {1} įrašas per pastaruosius metus} few {Paskutiniai {1} įrašai per pastaruosius metus} many {Paskutinio {1} įrašo per pastaruosius metus} other {Paskutinių {1} įrašų per pastaruosius metus}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originalus"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1412
#: src/pages/catchup.jsx:2023
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Atsakymai"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1414
#: src/pages/catchup.jsx:2035
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Pasidalinimai"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "Įrašo statistika nepasiekiama."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Peržiūrėti įrašo statistiką"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Paskutinis įrašas: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Nutildytas"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Užblokuota"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Privati pastaba"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Paminėti <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Versti biografiją"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Redaguoti privačią pastabą"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Pridėti privačią pastabą"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "Įjungti pranešimai apie @{username} įrašus."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "Išjungti pranešimai apie @{username} įrašus."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Išjungti pranešimus"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Įjungti pranešimus"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "Įjungti pasidalinimai iš @{username}."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "Išjungti pasidalinimai iš @{username}."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Išjungti pasidalinimus"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Įjungti pasidalinimus"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Pridėti / pašalinti iš sąrašų"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Nukopijuota nuorada"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "Nepavyksta atidaryti nuorodos."

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Kopijuoti"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Atrodo, kad bendrinimas neveikia."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Bendrinti…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "Atšauktas @{username} nutildymas"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Atšaukti nutildymą <0>@{username}></0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Nutildyti <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "Nutildytas @{username} dėl {0}"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "Nepavyksta nutildyti @{username}."

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Pašalinti <0>@{username}</0> iš sekėjų?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} pašalintas iš sekėjų"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Pašalinti sekėją…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "Bluokuoti <0>@{username}</0>?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "Atblokuotas @{username}"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "Užblokuotas @{username}"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "Nepavyksta atblokuoti @{username}."

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "Nepavyksta užblokuoti @{username}."

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Atblokuoti <0>@{username}</0>"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Bluokuoti <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Pranešti apie <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Redaguoti profilį"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "Atšaukti sekimo prašymą?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "Nebesekti @{0}?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Nebesekti…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Atšaukti…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Sekti"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1548
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Uždaryti"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Išversta biografija"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "Nepavyksta pašalinti iš sąrašo."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "Nepavyksta pridėti prie sąrašo."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Nepavyksta įkelti sąrašų."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "Nėra sąrašų."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Naujas sąrašas"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "Privati pastaba apie <0>@{0}</0>"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "Nepavyksta atnaujinti privačios pastabos."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Atšaukti"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Išsaugoti ir uždaryti"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "Nepavyksta atnaujinti profilio."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "Biografija"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Papildomi laukai"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Etiketė"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Turinys"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Išsaugoti"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "naudotojo vardas"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "serverio domeno vardas"

#: src/components/background-service.jsx:138
msgid "Cloak mode disabled"
msgstr "Išjungtas slėpimo režimas"

#: src/components/background-service.jsx:138
msgid "Cloak mode enabled"
msgstr "Įjungtas slėpimo režimas"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:431
#: src/pages/catchup.jsx:860
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Pagrindinis"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Sukurti"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Turi neišsaugotų pakeitimų. Atmesti šią įrašą?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Gali pridėti tik iki # failo.} few {Gali pridėti tik iki # failų.} many {Gali pridėti tik iki # failo.} other {Gali pridėti tik iki # failų.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Išskleisti"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Sumažinti"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Atrodo, kad uždarei pirminį langą."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Atrodo, kad pirminiame lange jau atidarytas sukūrimo laukas ir šiuo metu skelbiamas. Palauk, kol jis bus baigtas, ir pabandyk dar kartą vėliau."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Atrodo, kad pirminiame lange jau yra atidarytas sukūrimo laukas. Suskleisčius šiame lange, bus atmesti pakeitimai, kuriuos padarėte pirminiame lange. Tęsti?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Suskleisti"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Atsakant į @{0} įrašą (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "Atsakant į @{0} įrašą"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Redaguojamas šaltinio įrašas"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "Apklausa turi turėti bent 2 parinktis."

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Kai kurie apklausos pasirinkimai yra tušti."

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Kai kurios medijos neturi aprašymų. Tęsti?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "Nepavyko #{i} priedas."

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:975
msgid "Content warning"
msgstr "Turinio įspėjimas"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Turinio įspėjimas arba jautri medija"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Vieša"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "Neįtrauktas į sąrašą"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Tik sekėjai"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Privatus paminėjimas"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Skelbti savo atsakymą"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Redaguoti savo įrašą"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "Ką tu darai?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Žymėti mediją kaip jautrią"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Pridėti apklausą"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Pridėti pasirinktinį jaustuką"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Atsakyti"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Atnaujinti"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Skelbti"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "Atsisiunčiama GIF…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Nepavyko atsisiųsti GIF."

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Daugiau…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Įkelta"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Vaizdo aprašymas"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Vaizdo įrašo aprašymas"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Garso įrašo aprašymas"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Per didelis failo dydis. Įkeliant gali kilti problemų. Bandyk sumažinti failo dydį nuo {0} iki {1} arba mažiau."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Per didelis matmuo. Įkeliant gali kilti problemų. Bandyk sumažinti matmenis nuo {0}×{1} tšk. iki {2}×{3} tšk."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Per didelis kadrų dažnis. Įkeliant gali kilti problemų."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1058
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Pašalinti"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Klaida"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Redaguoti vaizdo aprašymą"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Redaguoti vaizdo įrašo aprašymą"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Redaguoti garso įrašo aprašymą"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Generuojamas aprašymas. Palauk…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "Nepavyko sugeneruoti aprašymo: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "Nepavyko sugeneruoti aprašymo."

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Generuoti aprašymą…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "Nepavyko sugeneruoti aprašymo: {0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>– eksperimentinė</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Atlikta"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "{0} pasirinkimas"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Keli pasirinkimai"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Trukmė"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Pašalinti apklausą"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Ieškoti paskyrų"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Pridėti"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Klaida įkeliant paskyras."

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Pasirinktiniai jaustukai"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Ieškoti jaustukų"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "Klaida įkeliant pasirinktinius jaustukus."

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Neseniai naudoti"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Kiti"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} daugiau…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Ieškoti GIF"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "Veikiama su „GIPHY“"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Rašyk, kad ieškotum GIF"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:880
msgid "Previous"
msgstr "Ankstesnis"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:897
msgid "Next"
msgstr "Kitas"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "Klaida įkeliant GIF."

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Neišsiųsti juodraščiai"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Atrodo, kad turi neišsiųstų juodraščių. Tęskime nuo ten, kur baigei."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Ištrinti šį juodraštį?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Klaida ištrinant juodraštį. Bandyk dar kartą."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Ištrinti…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Klaida gaunant atsakymo į būseną."

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Ištrinti visus juodraščius?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Klaida ištrinant juodraščius. Bandyk dar kartą."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Ištrinti visus…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Juodraščių nerasta."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1895
msgid "Poll"
msgstr "Apklausa"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Medija"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Atidaryti naujame lange"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Priimti"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Atmesti"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Priimta"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Atmesta"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nėra ką rodyti."

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Paskyros"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:513
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Rodyti daugiau…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:518
#: src/pages/search.jsx:459
msgid "The end."
msgstr "Pabaiga."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1586
msgid "Keyboard shortcuts"
msgstr "Spartieji klaviatūros klavišai"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Spartieji klaviatūros klavišos žinynas"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1611
msgid "Next post"
msgstr "Kitas įrašas"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1619
msgid "Previous post"
msgstr "Ankstesnis įrašas"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Praleisti karuselę į kitą įrašą"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Praleisti karuselę į ankstesnį įrašą"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Įkelti naujų įrašų"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1643
msgid "Open post details"
msgstr "Atidaryti įrašo informaciją"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Įvesti (Enter)</0> arba <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Išskleisti turinio įspėjimą arba<0/>perjungti išskleistą / suskleistą giją"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Uždaryti įrašą arba dialogo langus"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Gr (Esc)</0> arba <1>Naikinimo klavišas (Backspace)</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Fokusuoti stulpelį kelių stulpelių režime"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> iki <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Sukurti naują įrašą"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Sukurti naują įrašą (naujas langas)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Siųsti įrašą"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Vald (Ctrl)</0> + <1>Įvesti (Enter)</1> arba <2>⌘</2> + <3>Įvesti (Enter)</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Ieškoti"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Atsakyti (naujas langas)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Patinka (pamėgti)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> arba <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Pasidalinti"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Lyg2 (Shift)</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Pridėti į žymės"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Perjungti slėpimo režimą"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Lyg2 (Shift)</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Redaguoti sąrašą"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Nepavyksta redaguoti sąrašo."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Nepavyksta sukurti sąrašo."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Pavadinimas"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Rodyti atsakymus sąrašo nariams"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Rodyti atsakymus žmonėms, kuriuos seku"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Nerodyti atsakymų"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Paslėpti šio sąrašo pranešimus iš pagrindinio / sekimo"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Kurti"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Ištrinti šį sąrašą?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Nepavyksta ištrinti sąrašo."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Medijos aprašymas"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Versti"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Kalbėti"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Atidaryti originalią mediją naujame lange"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Atidaryti originalią mediją"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Bandymas apibūdinti vaizdą. Palauk…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Nepavyko apibūdinti vaizdo."

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Apibūdinti vaizdą…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Peržiūrėti įrašą"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Jautri medija"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtruota: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:964
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1843
msgid "Filtered"
msgstr "Filtruota"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Įrašas paskelbtas. Peržiūrėk."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Atsakymas paskelbtas. Peržiūrėk."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Įrašas atnaujintas. Peržiūrėk."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Meniu"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Perkrauti puslapį dabar, kad atnaujinti?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Yra naujas naujinimas…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:855
msgid "Catch-up"
msgstr "Pasivijimas"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Paminėjimai"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Pranešimai"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Naujas"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profilis"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Sąrašai"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Visi sąrašai"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Žymės"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1413
#: src/pages/catchup.jsx:2029
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "Patinka"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Sekamos saitažodžiai"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtrai"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Nutildyti naudotojai"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Nutildyti naudotojai…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Užblokuoti naudotojai"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Užblokuoti naudotojai…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Paskyros…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Prisijungti"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Tendencinga"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Vietinis"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Federacinis"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Spartieji klavišai / stulpeliai…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Nustatymai…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Pranešimas"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Šis pranešimas yra iš kitos tavo paskyros."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Peržiūrėti visus pranešimus"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} sureagavo į tavo įrašą su {emojiObject}"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} paskelbė įrašą."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {{0} seka tave.} few {<0><1>{0}</1> žmonės</0> seka tave.} many {<0><1>{0}</1> žmones</0> seka tave.}=1 {{account}} other {<0><1>{0}</1> žmonių</0> seka tave.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} paprašė tave sekti."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "Baigėsi apklausa, kurioje balsavai arba kurią sukūrei."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr ""

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr ""

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr ""

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr ""

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr ""

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr ""

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Prižiūrėjimo įspėjimas"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Administratorius (-ė) iš <0>{from}</0> pristabdė <1>{targetName}</1>, o tai reiškia, kad nebegali gauti iš jų naujienų ir su jais bendrauti."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "Tavo paskyra gavo prižiūrėjimo įspėjimą."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "Tavo paskyra buvo išjungta."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "Kai kurie tavo įrašai buvo pažymėtos kaip jautrios."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "Kai kurios tavo įrašai buvo ištrinti."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "Nuo šiol tavo įrašai bus pažymėti kaip jautrūs."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "Tavo paskyra buvo apribota."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "Tavo paskyra buvo pristabdyta."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Nežinomas pranešimo tipas: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Pasidalino / patiko…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Patiko…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Pasidalino…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Seka…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "Sužinoti daugiau <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Skaityti daugiau →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr ""

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr ""

#: src/components/poll.jsx:184
msgid "Vote"
msgstr ""

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Atnaujinti"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Rodyti rezultatus"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> balsas} few {<1>{1}</1> balsai} many {<1>{1}</1> balso} other {<1>{1}</1> balsų}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr ""

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr ""

#: src/components/poll.jsx:268
msgid "Ended"
msgstr ""

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr ""

#: src/components/poll.jsx:275
msgid "Ending"
msgstr ""

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr ""

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr ""

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr ""

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr ""

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr ""

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr ""

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr ""

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr ""

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr ""

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr ""

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr ""

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr ""

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr ""

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr ""

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr ""

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr ""

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr ""

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr ""

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr ""

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr ""

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr ""

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr ""

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr ""

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr ""

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr ""

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr ""

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr ""

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr ""

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr ""

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr ""

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr ""

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr ""

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr ""

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr ""

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr ""

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr ""

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr ""

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Tik vietinė"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Serveris"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Neprivalomas, pvz., mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr ""

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr ""

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr ""

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr ""

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr ""

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr ""

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr ""

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr ""

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr ""

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr ""

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr ""

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr ""

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr ""

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr ""

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr ""

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr ""

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr ""

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr ""

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr ""

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr ""

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr ""

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr ""

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr ""

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr ""

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr ""

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr ""

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr ""

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr ""

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr ""

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr ""

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr ""

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr ""

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr ""

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr ""

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr ""

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr ""

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr ""

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr ""

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr ""

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr ""

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr ""

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr ""

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr ""

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr ""

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr ""

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr ""

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr ""

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr ""

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr ""

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr ""

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr ""

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr ""

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr ""

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr ""

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr ""

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr ""

#: src/components/status.jsx:901
msgid "Boost…"
msgstr ""

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr ""

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr ""

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr ""

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr ""

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr ""

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr ""

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr ""

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr ""

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr ""

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr ""

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr ""

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr ""

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr ""

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr ""

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr ""

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr ""

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr ""

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr ""

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr ""

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr ""

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr ""

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr ""

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr ""

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr ""

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr ""

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr ""

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr ""

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr ""

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr ""

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr ""

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr ""

#: src/components/status.jsx:2071
msgid "Show media"
msgstr ""

#: src/components/status.jsx:2191
msgid "Edited"
msgstr ""

#: src/components/status.jsx:2268
msgid "Comments"
msgstr ""

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr ""

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr ""

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr ""

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr ""

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr ""

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr ""

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr ""

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr ""

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr ""

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr ""

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr ""

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr ""

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr ""

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr ""

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr ""

#: src/components/status.jsx:3254
msgid "Preview"
msgstr ""

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr ""

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr ""

#: src/components/timeline.jsx:447
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr ""

#: src/components/timeline.jsx:548
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr ""

#: src/components/timeline.jsx:937
#: src/components/timeline.jsx:944
#: src/pages/catchup.jsx:1860
msgid "Thread"
msgstr "Gija"

#: src/components/timeline.jsx:959
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr ""

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr ""

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr ""

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr ""

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Versti iš {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Automatinis ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Nepavyko išversti."

#: src/compose.jsx:32
msgid "Editing source status"
msgstr ""

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr ""

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr ""

#: src/compose.jsx:70
msgid "Close window"
msgstr ""

#: src/compose.jsx:86
msgid "Login required."
msgstr ""

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "Eiti į pagrindinį"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr ""

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr ""

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr ""

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr ""

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr ""

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr ""

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr ""

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr ""

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr ""

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr ""

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr ""

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr ""

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr ""

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr ""

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr ""

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr ""

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr ""

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr ""

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr ""

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr ""

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr ""

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr ""

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr ""

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr ""

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr ""

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr ""

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr ""

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr ""

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr ""

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr ""

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr ""

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr ""

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr ""

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr ""

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr ""

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr ""

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr ""

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr ""

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr ""

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr ""

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr ""

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr ""

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr ""

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr ""

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr ""

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr ""

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr ""

#: src/pages/catchup.jsx:866
#: src/pages/catchup.jsx:890
msgid "Catch-up <0>beta</0>"
msgstr ""

#: src/pages/catchup.jsx:880
#: src/pages/catchup.jsx:1552
msgid "Help"
msgstr ""

#: src/pages/catchup.jsx:896
msgid "What is this?"
msgstr "Kas tai?"

#: src/pages/catchup.jsx:899
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Pasivijimo informacija – tai atskira sekimu laiko skalė, suteikianti aukšto lygio peržiūrą iš pirmo žvilgsnio, su paprasta, el. pašto įkvėpta sąsaja, kad būtų galima lengvai rūšiuoti ir filtruoti įrašus."

#: src/pages/catchup.jsx:910
msgid "Preview of Catch-up UI"
msgstr ""

#: src/pages/catchup.jsx:919
msgid "Let's catch up"
msgstr "Pasivykime"

#: src/pages/catchup.jsx:924
msgid "Let's catch up on the posts from your followings."
msgstr "Pasivykime tavo sekimų įrašus."

#: src/pages/catchup.jsx:928
msgid "Show me all posts from…"
msgstr "Rodyti visus įrašus iš…"

#: src/pages/catchup.jsx:951
msgid "until the max"
msgstr ""

#: src/pages/catchup.jsx:981
msgid "Catch up"
msgstr ""

#: src/pages/catchup.jsx:987
msgid "Overlaps with your last catch-up"
msgstr ""

#: src/pages/catchup.jsx:999
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1008
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Pastaba: tavo serveris gali rodyti ne daugiau kaip 800 įrašų pagrindinėje laiko skalėje, nepaisant laiko intervalo. Gali būti mažiau arba daugiau."

#: src/pages/catchup.jsx:1018
msgid "Previously…"
msgstr "Anksčiau…"

#: src/pages/catchup.jsx:1036
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# įrašas} few {# įrašai} many {# įrašo} other {# įrašų}}"

#: src/pages/catchup.jsx:1046
msgid "Remove this catch-up?"
msgstr ""

#: src/pages/catchup.jsx:1067
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr ""

#: src/pages/catchup.jsx:1082
msgid "Fetching posts…"
msgstr ""

#: src/pages/catchup.jsx:1085
msgid "This might take a while."
msgstr ""

#: src/pages/catchup.jsx:1120
msgid "Reset filters"
msgstr ""

#: src/pages/catchup.jsx:1128
#: src/pages/catchup.jsx:1558
msgid "Top links"
msgstr ""

#: src/pages/catchup.jsx:1244
msgid "Shared by {0}"
msgstr ""

#: src/pages/catchup.jsx:1283
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr ""

#: src/pages/catchup.jsx:1368
msgid "{0, plural, one {# author} other {# authors}}"
msgstr ""

#: src/pages/catchup.jsx:1380
msgid "Sort"
msgstr ""

#: src/pages/catchup.jsx:1411
msgid "Date"
msgstr ""

#: src/pages/catchup.jsx:1415
msgid "Density"
msgstr ""

#: src/pages/catchup.jsx:1453
msgid "Authors"
msgstr ""

#: src/pages/catchup.jsx:1454
msgid "None"
msgstr ""

#: src/pages/catchup.jsx:1470
msgid "Show all authors"
msgstr ""

#: src/pages/catchup.jsx:1521
msgid "You don't have to read everything."
msgstr ""

#: src/pages/catchup.jsx:1522
msgid "That's all."
msgstr ""

#: src/pages/catchup.jsx:1530
msgid "Back to top"
msgstr ""

#: src/pages/catchup.jsx:1561
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr ""

#: src/pages/catchup.jsx:1567
msgid "Sort: Density"
msgstr ""

#: src/pages/catchup.jsx:1570
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr ""

#: src/pages/catchup.jsx:1577
msgid "Group: Authors"
msgstr ""

#: src/pages/catchup.jsx:1580
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr ""

#: src/pages/catchup.jsx:1627
msgid "Next author"
msgstr ""

#: src/pages/catchup.jsx:1635
msgid "Previous author"
msgstr ""

#: src/pages/catchup.jsx:1651
msgid "Scroll to top"
msgstr ""

#: src/pages/catchup.jsx:1842
msgid "Filtered: {0}"
msgstr ""

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr ""

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr ""

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr ""

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr ""

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr ""

#: src/pages/filters.jsx:42
msgid "Never"
msgstr ""

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr ""

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr ""

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr ""

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr ""

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr ""

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr ""

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr ""

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr ""

#: src/pages/filters.jsx:355
msgid "Title"
msgstr ""

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr ""

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr ""

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr ""

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr ""

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr ""

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr ""

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr ""

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr ""

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr ""

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr ""

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr ""

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr ""

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr ""

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr ""

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr ""

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr ""

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr ""

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr ""

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr ""

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr ""

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr ""

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr ""

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr ""

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr ""

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr ""

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr ""

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr ""

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr ""

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr ""

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr ""

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr ""

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr ""

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Įvesk naują serverį, pvz., mastodon.social"

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr ""

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr ""

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr ""

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr ""

#: src/pages/home.jsx:234
msgid "See all"
msgstr ""

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Kol kas nieko."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Tvarkyti narius"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr ""

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Pašalinti…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# sąrašas} few {# sąrašai} many {# sąrašo} other {# sąrašų}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Kol kas nėra sąrašų."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "pvz., mastodon.social"

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr ""

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr ""

#: src/pages/login.jsx:233
msgid "Continue"
msgstr ""

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr ""

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr ""

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr ""

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr ""

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr ""

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr ""

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr ""

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr ""

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr ""

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr ""

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr ""

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr ""

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr ""

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr ""

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr ""

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr ""

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr ""

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr ""

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr ""

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr ""

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr ""

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Leisti"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr ""

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr ""

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr ""

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr ""

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr ""

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr ""

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr ""

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr ""

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr ""

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr ""

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr ""

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Saitažodžiai"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Žiūrėti daugiau"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Žiūrėti daugiau paskyrų"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Paskyrų nerasta."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Žiūrėti daugiau saitažodžių"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr ""

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr ""

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr ""

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Nustatymai"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Išvaizda"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "Šviesi"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "Tamsi"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "Automatinis"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Teksto dydis"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr ""

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr ""

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr ""

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr ""

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "Sinchronizuota"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr ""

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr ""

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr ""

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr ""

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr ""

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr ""

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr ""

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr ""

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr ""

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr ""

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr ""

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr ""

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr ""

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:692
msgid "About"
msgstr ""

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr ""

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr ""

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr ""

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr ""

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr ""

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr ""

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr ""

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr ""

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr ""

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:999
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr ""

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr ""

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Skelbti"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Klaida: {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr ""

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr ""

#: src/pages/status.jsx:1048
msgid "Back"
msgstr ""

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr ""

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr "Eksperimentinis"

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr ""

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr ""

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr ""

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr ""

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "Tendencinga ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "Tendencingos naujienos"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr ""

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Minimalistinė „Mastodon“ žiniatinklio kliento programa."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Prisijungti su „Mastodon“"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Prijunk esamą „Mastodon“ / Fediverso paskyrą.<0/>Tavo kredencialai šiame serveryje nėra saugomi."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Daugiasaitažodžių laiko skalė"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Iki 5 saitažodžių, sujungtų į vieną laiko skalę."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Atrodo, kad tavo naršyklė blokuoja iškylančiuosius langus."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Įrašo juodraštis šiuo metu sumažintas. Paskelbk arba atmesk jį prieš sukuriant naują."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Įrašas šiuo metu atidarytas. Paskelbk arba atmesk jį prieš sukuriant naują."

